<app-twilio-call-viewer
  [callType]="callType"
  [remoteUser]="(inboundCallOptions$ | async).initiator"
  [inboundCallOptions]="inboundCallOptions$ | async"
></app-twilio-call-viewer>
